import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  Link,
} from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

interface SupportDialogProps {
  open: boolean
  accessToken: string
  careerId: string
  onClose: () => void
  onCopy: (text: string, label: string) => void
}

export function SupportDialog({ open, accessToken, careerId, onClose, onCopy }: SupportDialogProps) {
  const debugInfo = `アクセストークン: \`${accessToken}\`\nキャリア情報 ID: \`${careerId}\``

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>サポート</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <TextField
            label="デバッグ情報"
            value={debugInfo}
            slotProps={{
              input: {
                readOnly: true,
                onClick: (e) => {
                  if (e.target instanceof HTMLTextAreaElement) {
                    e.target.select()
                  }
                },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => onCopy(debugInfo, 'デバッグ情報')} edge="end">
                      <ContentCopyIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
            multiline
            rows={6}
            fullWidth
          />
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" color="text.secondary">
              問題が発生した場合は、上記の情報を Slack で{' '}
              <Link href="slack://user?team=T04MG76E3&id=U09GT1CEP0S" sx={{ fontWeight: 'bold' }}>
                @nagacchi.atsushi.ngs.nagase
              </Link>{' '}
              にDMしてください。
              <br />
              秘匿情報なので、チャネルに投稿しないよう、ご注意お願いします。
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>閉じる</Button>
      </DialogActions>
    </Dialog>
  )
}
